<!-- 组件说明 -->
<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      offset="20"
      @load="onLoadMore"
      :immediate-check="false"
    >
      <!-- <img
              v-show="item.ifExpired"
              class="overdue"
              src="../../common/images/overdue.png"
              alt
            /> -->
      <!-- 展示子组件 -->
      <distribution-item
        v-for="(item, index) in undistributionList"
        :key="item.id"
        :noDistributionTime="item.noDistributionTime"
        :distributionItem="item.recommend"
        :distributionIndex="index"
        :projectCode="projectCode"
        @initList="initList"
        :isShowDistribution="isShowDistribution"
      />
    </van-list>
  </div>
</template>

<script>
import { List as VanList } from "vant";
import { getPositionsByuserId } from "@/api/modules/oldNew.js";

import DistributionItem from "./DistributionComponent/DistributionItem";
export default {
  components: {
    VanList,
    DistributionItem,
  },
  props: {
    projectCode: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      finished: false,
      load_more: false, // 是否加载更多
      nowpage: 1, // 当前页数
      undistributionList: [],
      consultant: "",
      // 判断是否展示立即分配按钮
      isShowDistribution: true,
    };
  },
  computed: {},
  created() {
    this.getData();
  },
  mounted() {
    this.$nextTick(() => {
      getPositionsByuserId({}).then((res) => {
        if (res.body.position == 5 || res.body.position == 6) {
          this.isShowDistribution = false;
        }
      });
    });
  },
  methods: {
    //获取数据移动端查看推荐列表
    getData() {
      let params = {
        projectCode: this.projectCode,
        current: this.nowpage,
        size: 10,
        statuses: 1,
        requestEntry: 1,
      };
      this.$api.getListByProjectCode(params).then((res) => {
        res.body.records.forEach((item) => {
          this.undistributionList.push(item);
        });
        if (this.nowpage >= res.body.pages) {
          this.finished = true;
          this.loading = false;
        } else {
          this.loading = false;
          this.finished = false;
        }
      });
    },
    // 下拉加载更多
    onLoadMore() {
      if (!this.finished) {
        // 是否还有下一页
        this.nowpage = Number(this.nowpage) + 1;
        this.getData();
      }
    },

    clearData() {
      this.nowpage = 1;
      this.finished = false;
      this.undistributionList = [];
    },
    // 刷新列表
    initList() {
      this.clearData();
      this.getData();
    },
  },
  watch: {
    projectCode() {
      this.clearData();
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
//@import url()
</style>
